import { render, staticRenderFns } from "./PersonalLoanCaseBankDetails.vue?vue&type=template&id=91a4aa7a"
import script from "./PersonalLoanCaseBankDetails.vue?vue&type=script&lang=js"
export * from "./PersonalLoanCaseBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports